<template>
  <div id="page-fixed-bearings-dimension">
    <div class="row">
      <div class="col-lg-6">
        <FixedBearingsFormEffects />
        <FixedBearingsFormBearingDimension />
        <!-- <FixedBearingsFormPyramide /> -->
        <!--        <FixedBearingsHelp />-->
      </div>
      <div class="col-lg-6">
        <FixedBearingsFormHoles />
        <div class="row">
          <div class="col-md-6">
            <FixedBearingsFormDialogDimension />
          </div>
          <div class="col-md-6">
            <FixedBearingsFormVisual2D />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <FixedBearingsConventionalFormBearingSelection />
      </div>
      <div class="col-lg-6">
        <FixedBearingsFormBearingSelection />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <h3>{{ $t('bearings.headlineEdgeDistanceEC') }}</h3>
      </div>
      <div class="col-lg-6">
        <FixedBearingsEdgeDistanceECToolInput
          @completion-changed="edgeDistanceComplete = $event"
        />
      </div>
      <div class="col-lg-6">
        <FixedBearingsEdgeDistanceECToolVisualisation />
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="edgeDistanceComplete"
        ref="edgeContact"
        class="row"
      >
        <div class="col-lg-12">
          <h3>{{ $t('tabs.tabEdgeContact') }}</h3>
        </div>
        <div class="col-lg-12">
          <ToolsFormEdgeContact />
        </div>
      </div>
    </transition>

    <!-- Toast Hint -->
    <ScrollHint
      :visible="showHint"
      :message="$t('bearings.newCalculationsAvailable')"
      :button="$t('bearings.scrollHintButton')"
      @scroll-to="scrollToSection"
      @dismiss="showHint = false"
    />
  </div>
</template>

<script>
import FixedBearingsFormEffects from '@/components/fixedBearings/FixedBearingsFormEffects.vue';
import FixedBearingsFormBearingDimension from '@/components/fixedBearings/FixedBearingsFormBearingDimension.vue';
import FixedBearingsFormHoles from '@/components/fixedBearings/FixedBearingsFormHoles.vue';
// import FixedBearingsFormPyramide from '@/components/fixedBearings/FixedBearingsFormPyramide.vue';
import FixedBearingsFormDialogDimension from '@/components/fixedBearings/FixedBearingsFormDialogDimension.vue';
import FixedBearingsFormBearingSelection from '@/components/fixedBearings/FixedBearingsFormBearingSelection.vue';
import FixedBearingsFormVisual2D from '@/components/fixedBearings/FixedBearingsFormVisual2D.vue';
// import FixedBearingsHelp from '@/components/fixedBearings/FixedBearingsHelp.vue';
import FixedBearingsConventionalFormBearingSelection from '@/components/fixedBearings/FixedBearingsConventionalFormBearingSelection.vue';
import FixedBearingsEdgeDistanceECToolInput
from '../../components/fixedBearings/FixedBearingsEdgeDistanceECToolInput.vue';
import FixedBearingsEdgeDistanceECToolVisualisation
from '../../components/fixedBearings/FixedBearingsEdgeDistanceECToolVisualisation.vue';
import ToolsFormEdgeContact from '../../components/tools/ToolsFormEdgeContact.vue';
import ScrollHint from '../../components/fixedBearings/ScrollHint.vue';

export default {
  name: 'FixedBearingsDimension',
  components: {
    ToolsFormEdgeContact,
    FixedBearingsFormVisual2D,
    FixedBearingsFormEffects,
    FixedBearingsFormBearingDimension,
    FixedBearingsFormHoles,
    FixedBearingsFormDialogDimension,
    FixedBearingsFormBearingSelection,
    FixedBearingsConventionalFormBearingSelection,
    FixedBearingsEdgeDistanceECToolInput,
    FixedBearingsEdgeDistanceECToolVisualisation,
    // FixedBearingsHelp,
    ScrollHint,
  },
  data() {
    return {
      edgeDistanceComplete: false,
      showHint: false,
    };
  },
  watch: {
    edgeDistanceComplete(newVal) {
      if (newVal) {
        this.showHint = true;
      }
    },
  },
  methods: {
    scrollToSection() {
      this.$refs.edgeContact.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
